module.exports = __webpack_public_path__ + "static/img/wangzhan_dingzhi_back.6898d95.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/wangzhan_dingzhi_back.png
// module id = 1fmi
// module chunks = 0